import accounting from 'accounting';

accounting.settings = {
  number: {
    precision: 0,
    thousand: ' ',
    decimal: '.',
  },
};

// eslint-disable-next-line import/prefer-default-export
export const numberFormat = {
  format: (val): string => accounting.formatNumber(val),
};
